import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=0b4b4d20&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicLayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=0b4b4d20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4b4d20",
  null
  
)

export default component.exports